import { ColumnDef } from '@tanstack/react-table';
import { useState } from 'react';
import { Stack } from 'react-bootstrap';
import ConfirmationModal from '../../../components/modals/ConfirmationModal';
import { LinkCell } from '../../../components/tables/cellComponents/LinkCell';
import { useToast } from '../../../context/ToastContext';
import { useDeleteCountryFactMutation } from '../../../services/endpoints/content/countryFacts';
import { Document } from '../../../types/content.type';
import { getErrorMessage } from '../../utils';

const DeleteCountryFactButton: React.FC<{ id: number }> = ({ id }) => {
  const [showModal, setShowModal] = useState(false);
  const [deleteCountryFact, { isLoading }] = useDeleteCountryFactMutation();
  const { addToast } = useToast();

  const handleDelete = async () => {
    try {
      await deleteCountryFact(id).unwrap();
      addToast('Country fact deleted successfully', 'success');
      setShowModal(false);
    } catch (e) {
      addToast(getErrorMessage(e), 'error');
    }
  };

  return (
    <>
      <button
        className="text-info fw-bolder btn btn-link p-0"
        style={{ fontSize: '.875rem', textDecoration: 'underline' }}
        onClick={() => setShowModal(true)}
      >
        Delete
      </button>
      <ConfirmationModal
        show={showModal}
        title="Delete Country Fact"
        message="Are you sure you want to delete this country fact?"
        confirmText="Yes, Delete"
        cancelText="Cancel"
        onConfirm={handleDelete}
        onCancel={() => setShowModal(false)}
        isLoading={isLoading}
      />
    </>
  );
};

export const countryFactsColumns: ColumnDef<Document>[] = [
  {
    header: 'ID',
    accessorKey: 'id',
    cell: ({ getValue }) => (
      <LinkCell
        content={getValue<number>()}
        url={`/admin/content/country-facts/${getValue<number>()}`}
      />
    )
  },
  {
    header: 'Name',
    accessorKey: 'name'
  },

  {
    header: () => null,
    id: 'actions',
    enableSorting: false,
    cell: ({ row }) => (
      <Stack
        direction="horizontal"
        gap={2}
      >
        <LinkCell
          content="View"
          url={`/admin/content/country-facts/${row.original.id}`}
          underline
        />
        <LinkCell
          content="Edit"
          url={`/admin/content/country-facts/${row.original.id}/edit`}
          underline
        />
        <DeleteCountryFactButton id={row.original.id} />
      </Stack>
    )
  }
];
